import React, { Component } from 'react';
import classNames from 'classnames';
import '../../style/ReactMediaPlayer.css';
import { Media, controls, utils, withMediaProps } from 'components/ReactMediaPlayerSrc';
import PlayPause from './PlayPause';
import Icon from '../../helper/Icon';

const { SeekBar } = controls;
const { formatTime } = utils;

const DurationCustom = ({ media: { currentTime, duration } }) => (
  <div className="media-control media-control--duration">{formatTime(duration - currentTime)}</div>
);

const WMDurationCustom = withMediaProps(DurationCustom);

export default class AudioPlayer extends Component {
  render() {
    if (!this.props.src) return null;
    const seekBarClass = classNames('media-control', { 'mini-seek-bar': this.props.onlySeekbar });
    const mediaControlsClass = classNames('media-controls', {
      'mini-mode': this.props.onlySeekbar
    });
    // console.log('this.props.autoPlay::', this.props.autoPlay);
    const autoPlay = 'autoPlay' in this.props ? this.props.autoPlay : false;
    return (
      <div className="react-media-player" style={this.props.style || null}>
        <Media src={this.props.src} autoPlay={autoPlay} vendor="audio">
          {Player => (
            <div>
              {Player}
              <nav className={mediaControlsClass} style={this.props.controlsWrapperStyle || null}>
                {this.props.onlySeekbar ? null : (
                  <PlayPause className="media-control media-control--play-pause" />
                )}
                <SeekBar className={seekBarClass} />
                {this.props.onlySeekbar ? null : <WMDurationCustom />}
                {this.props.showClose ? (
                  <div className="rmp-close-wrapper">
                    <span className="rmp-separator" />
                    <div className="rmp-close-icon" onClick={this.props.onClose}>
                      <Icon
                        icon="close"
                        fill="var(--color-grey2)"
                        viewBox="4 4 16 16"
                        size="15px"
                      />
                    </div>
                  </div>
                ) : null}
              </nav>
            </div>
          )}
        </Media>
      </div>
    );
  }
}
